import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-help-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './help-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./help-page.component.scss'],
})
export class HelpPageComponent {
  quickSteps = [
    'Create a customer and set builder/model/elevation.',
    'Confirm rooms and auto-added blinds.',
    'Measure each blind and review warnings.',
    'Generate and save the estimate.',
    'Download the estimate PDF for the customer.',
  ];

  contacts = [
    { label: 'Scheduling', value: '(512) 555-0123' },
    { label: 'Support', value: 'support@doyourshades.com' },
    { label: 'Warehouse', value: 'Georgetown, TX' },
  ];
}
